import { render, staticRenderFns } from "./MenuTreeView.vue?vue&type=template&id=041fbb0e&scoped=true"
import script from "./MenuTreeView.vue?vue&type=script&lang=ts"
export * from "./MenuTreeView.vue?vue&type=script&lang=ts"
import style0 from "./MenuTreeView.vue?vue&type=style&index=0&id=041fbb0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fbb0e",
  null
  
)

export default component.exports